routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportBillfold', {
      url: "/reportes/cartera",
      template: `<billfold sh-ctrl="shCtrl"></billfold>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/billfold/billfold.config.js
 **/